import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class TitulosPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        const { buscaDataIni, buscaDataFim, buscaNumero, buscaControle, buscaTipo,
            buscaPessoa, buscaPlanoCta, buscaSituacao, buscaDescricao } = this.props.filtros;

        let dataIni = '';
        if ((buscaDataIni) && (buscaDataIni !== undefined)) {
            dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
        let dataFim = '';
        if ((buscaDataFim) && (buscaDataFim !== undefined)) {
            dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }

        axios
            .get('/titulos', {
                params: {
                    print: true,
                    controle: buscaControle,
                    numero: buscaNumero,
                    descricao: buscaDescricao,
                    tipo: buscaTipo.key,
                    situacao: buscaSituacao.key,
                    pessoa: buscaPessoa.key,
                    ctaFin: buscaPlanoCta.key,
                    dataIni,
                    dataFim,
                    tipoTela: 'TIT'
                }
            })
            .then(response => {
                const { data } = response;
                this.setState({
                    listaRegistros: data.dados,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (ven_vlr_total, registro) => {
        return (
            <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            <span></span>
        }
    }

    renderSituacao = (tit_situacao) => {
        if (tit_situacao === 'A') {
            return (
                <span>ABERTO</span>
            );
        } else if (tit_situacao === 'P') {
            return (
                <span>PAGO</span>
            );
        } else if (tit_situacao === 'F') {
            return (
                <span>FATURADO</span>
            );
        } else if (tit_situacao === 'C') {
            return (
                <span>CANCELADO</span>
            );
        }
    };



    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Lançamentos Financeiros
                        </div>

                        {/* <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                                <span style={{ fontWeight: "bold" }}>Quantidade: </span>
                                <span>{this.props.qtdeTit}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Valor Total: </span>
                                <span>R$ {this.renderValor(this.props.totalTit)}</span>
                            </Col>
                        </Row> */}

                        <Row style={{ marginTop: -20 }}>
                            <Table
                                pagination={false}
                                dataSource={listaRegistros}
                                className="tabela"
                                rowKey={(listaRegistros => listaRegistros.tit_idf)}
                                loading={{
                                    spinning: carregando,
                                    tip: 'Carregando. Aguarde...',
                                    size: "large"
                                }}
                            >
                                <Column
                                    key="tit_controle"
                                    dataIndex="tit_controle"
                                    title="Controle"
                                    width={80}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="tit_numero"
                                    dataIndex="tit_numero"
                                    title="Número"
                                    width={80}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="tit_data_emissao"
                                    dataIndex="tit_data_emissao"
                                    title="Emissão"
                                    render={this.renderData}
                                    width={90}
                                    align="center"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="tit_valor"
                                    dataIndex="tit_valor"
                                    title="Valor"
                                    render={this.renderValor}
                                    width={80}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="tit_situacao"
                                    dataIndex="tit_situacao"
                                    title="Situação"
                                    render={this.renderSituacao}
                                    width={70}
                                    align="center"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="pes_nome"
                                    dataIndex="pes_nome"
                                    title="Cliente"
                                    width={150}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="pc_descricao"
                                    dataIndex="pc_descricao"
                                    title="Conta Financeia"
                                    width={150}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="tit_descricao"
                                    dataIndex="tit_descricao"
                                    title="Descrição"
                                    width={150}
                                    align="left"
                                    className="listaCadastro"
                                />

                            </Table>
                        </Row>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default TitulosPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/TitulosPrintModal.js